module.exports = __webpack_public_path__ + "img/Iga.83a765cd.jpeg";